// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"b09a3ee7","798":"dfa2309b","956":"07f8f56a"}[chunkId] + ".chunk.js";
};